import { coinbaseWallet } from 'wagmi/connectors';

// "Base Account" usually refers to the Smart Wallet experience
const baseAccountIcon = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAALZJREFUaEPtmjEOhDAMBNc/O14GvOzys3CAKK6eAlmaVGl2Zc+kTOU685vkc9/bnD2prZK5/TZY24z9P+g4F5hNh7/GdoG37WlAA5CATwgCxHENYISwQAMQII5rACOEBRqAAHFcAxghLNAABIjjGsAIYYEGIEAc1wBGCAs0AAHiuAYwQligAQgQxzWAEcICDUCAOK4BjBAWaAACxHENYISwQAMQII6fBjr+VHkW3+u+tfyxMpJaDgYzYxb/ALZVAAAAAElFTkSuQmCC'; // Reusing Coinbase icon

export const baseAccountConnector = () => {
    // For Base Account, we use the official coinbaseWallet connector which supports Smart Wallet (Passkeys)
    // We don't use 'injected' because Smart Wallet doesn't require an extension.
    // We wrap it to match the "Bitget way" interface (downloadUrls, etc.)
    
    const c = coinbaseWallet({
        appName: 'LeverUp',
        preference: 'smartWalletOnly', // Force Smart Wallet for "Base Account"
    });

    return (ctx: any) => {
        const connector = c(ctx);
        
return {
            ...connector,
            getProvider: () => connector.getProvider(),
            id: 'base_account',
            name: 'Base Account',
            icon: baseAccountIcon,
            getWalletConnectDeeplink: null,
            getQrCode: () => null,
            
            // Smart Wallet is always "installed" via web
            get installed() {
                return true; 
            },
            get suggested() {
                return false;
            },
            downloadUrls: {
                get download() {
                    return 'https://www.smartwallet.dev/';
                },
            },
        };
    };
};

